<template>
  <div class="ws-data-table-pagenate">
    <WsPagenate
      @pageto="$_onPageto($event)"
      :currentPage="currentPage"
      :lastPage="lastPage"
    ></WsPagenate>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: [Number, String],
    lastPage: Number
  },
  methods: {
    $_onPageto($event) {
      this.$emit("pageto", $event);
    }
  }
};
</script>

<style>
</style>